import { componentWithVariants, demoFile, variant, extend, story, CLICK } from 'system/demo';
import { ArticleManager, ArticleManagerFeature } from '../article-manager';
import { NewInstanceScreen } from 'feature/editorial-dash/question-topic-manager';

demoFile('open-modules/zdf/feature/editorial-dash/article-manager');

const baseConfig = {
    instanceTopLeftWidgets: [],
    instanceTopRightWidgets: [],
    instanceBodyWidgets: [],
    instanceBottomLeftWidgets: [],
    instanceBottomRightWidgets: [],
    instanceFilters: [],
    newInstanceWidgets: [],
    newInstanceCreateBlockers: [],
    newInstanceCreators: [],
    newInstancePostCreateTriggers: []
};

const loadedState = {
    serverCall: {
        article: {
            getArticleList: async () => ['article-a', 'article-b']
        }
    }
};

const loadingState = {
    serverCall: {
        article: {
            getArticleList: async () => null
        }
    }
};

componentWithVariants('ArticleManager', ArticleManager, { config: baseConfig }, [
    variant('Loaded', { state: loadedState, config: baseConfig }),
    variant('Loading', { state: loadingState, config: baseConfig })
]);

extend('NewInstanceScreen', 'Article Manager', NewInstanceScreen, {
    args: { structureKey: 'article' },
    features: ['question-topic-manager', 'article-manager'],
    config: { ...baseConfig, ...ArticleManagerFeature.providesConfig },
    structureKey: 'editorialdash'
}, [
    story('Create Article', [
        CLICK('Create article')
    ])
]);
